module.exports = __webpack_public_path__ + "static/media/3.e615d0a1.jpg";